import api from './api';

export const getMembers = async (params) => {
  const response = await api.get('/members', { params });
  return response.data;
};

export const getMemberById = async (id) => {
  const response = await api.get(`/members/${id}`);
  return response.data;
};

export const approveMember = async (id) => {
  const response = await api.post(`/members/${id}/approve`);
  return response.data;
};

export const suspendMember = async (id, reason) => {
  const response = await api.post(`/members/${id}/suspend`, { reason });
  return response.data;
};

export const reactivateMember = async (id) => {
  const response = await api.post(`/members/${id}/reactivate`);
  return response.data;
};

export const getBeneficiaries = async (memberId) => {
  const response = await api.get(`/members/${memberId}/beneficiaries`);
  return response.data;
};

export const updateBeneficiaries = async (memberId, beneficiaries) => {
  const response = await api.put(`/members/${memberId}/beneficiaries`, { beneficiaries });
  return response.data;
};

export const getMyMemberProfile = async () => {
  const response = await api.get('/members/me/profile');
  return response.data;
};

export const getMyDashboard = async () => {
  const response = await api.get('/members/me/dashboard');
  return response.data;
};

// NEW: update the logged‑in member's own beneficiaries
export const updateMyBeneficiaries = async (beneficiaries) => {
  const response = await api.put('/members/me/beneficiaries', { beneficiaries });
  return response.data;
};

export const createMyCase = async (data) => {
  const response = await api.post('/members/me/cases', data);
  return response.data;
};